module.exports = __webpack_public_path__ + "img/chpc_index_honor7.ffe201cf.png";